import React, { useEffect, useRef, useState } from 'react';
import ScenePlayer from './ScenePlayer';
import apiClient from '../services/apiClient';
import { getLanguage, t } from '../i18n';
import nextRepeatNoSprite from '../assets/sprites/nextRepeatNo.webp';

const NO_CARDS_SCENE_TRIGGER = 'practice.before.nomorecard';

function NoCardsPracticeScene({ onContinue }) {
  const language = getLanguage();
  const [scene, setScene] = useState(null);
  const onContinueRef = useRef(onContinue);

  useEffect(() => {
    onContinueRef.current = onContinue;
  }, [onContinue]);

  useEffect(() => {
    let cancelled = false;

    apiClient.getRandomScene({ trigger: NO_CARDS_SCENE_TRIGGER })
      .then((result) => {
        if (cancelled) return;

        if (result?.scene) {
          setScene(result.scene);
          return;
        }

        onContinueRef.current?.();
      })
      .catch((error) => {
        console.warn('Failed to load no-cards practice scene:', error);
        if (!cancelled) {
          onContinueRef.current?.();
        }
      });

    return () => {
      cancelled = true;
    };
  }, [language]);

  if (!scene) return null;

  return (
    <ScenePlayer
      scene={scene}
      onContinue={onContinue}
      variant="coaching"
      continueLabel={t('common.ok', language)}
      messageTestId="no-cards-practice-scene-message"
      eventSpriteSrc={nextRepeatNoSprite}
      eventSpriteFrameCount={16}
      eventSpriteDurationMs={1000}
    />
  );
}

export default NoCardsPracticeScene;
